export interface NewTrainingDetails {
    objectives: string,
    required_level: string,
    concerned_public: string,
    program: NewProgram[]
}

export interface technologies {
    id: number,
    title: string,
    duration: string,
    description: string,
    price: number,
    tag: string,
}

export interface PopularTags {
    id: number,
    state: string,
    demanded: string,
}

export interface NewTraining {
    id: number,
    type: string,
    title: string,
    description: string,
    icon: string,
    include: string[],
    duration: string,
    slug: string,
    trainingPlaces: string[],
    category: string[],
    min_price: number | string // number or string if we want to display "Sur devis",
    technologies: technologies[],
    popularTags: PopularTags[],
    period: string,
    city: string,
    places: string,
    // trainingDetails?: NewTrainingDetails
}

export interface NewProgram {
    title: string,
    content: NewContent[]
}

export interface NewContent {
    title: string,
    text: string
}

export const newTrainings: NewTraining[] = [
    {
        id: 0,
        type: "catalog",
        title: "Développement Logiciel",
        description: "Pour ingénieurs systèmes et équipes IT en charge de l'infrastructure et du déploiement.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [],
        duration: "4-5 jours",
        period: "10–14 juin 2025",
        city: "Douala",
        places: "Ouvert",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 900000,
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            // {
            //     id: 0,
            //     state: "Nouveau",
            //     demanded: "Développement logiciel"
            // },
            // {
            //     id: 1,
            //     state: "Nouveau",
            //     demanded: "Développement logiciel"
            // },
            // {
            //     id: 2,
            //     state: "Terminé",
            //     demanded: "Administration système"
            // }
        ],
    },
    {
        id: 1,
        type: "catalog",
        title: "Cloud & DevOps",
        description: "Pour ingénieurs systèmes et équipes IT en charge de l'infrastructure et du déploiement.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [],
        duration: "4-5 jours",
        period: "10–14 juin 2025",
        city: "Douala",
        places: "Ouvert",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 900000,
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "",
                demanded: "Très demandée"
            },
            // {
            //     id: 1,
            //     state: "En cours",
            //     demanded: "Développement logiciel"
            // },
            // {
            //     id: 2,
            //     state: "Terminé",
            //     demanded: "Administration système"
            // }
        ],
    },
    {
        id: 2,
        type: "catalog",
        title: "Data & Business Intelligence",
        description: "Pour analystes, contrôleurs de gestion et décideurs souhaitant exploiter leurs données.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [],
        duration: "4-5 jours",
        period: "10–14 juin 2025",
        city: "Douala",
        places: "Ouvert",
        slug: "data-business-intelligence",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 600000,
        technologies: [
            {
                id: 0,
                title: "Data Analytics avec Python",
                duration: "4 jours",
                description: "Pandas, viualtisation, analyses",
                price: 800000,
                tag: "Python Analytics",
            },
            {
                id: 1,
                title: "Power BI & Data Visualization",
                duration: "3 jours",
                description: "Tableaux de bord, DAX, rapports",
                price: 600000,
                tag: "Power BI",
            },
            {
                id: 2,
                title: "Analyse de données pour entreprises",
                duration: "4 jours",
                description: "KPIs, decisions data-driven",
                price: 700000,
                tag: "Data viz",
            }
        ],
        popularTags: [
            // {
            //     id: 0,
            //     state: "Nouveau",
            //     demanded: "Développement logiciel"
            // },
            // {
            //     id: 1,
            //     state: "Nouveau",
            //     demanded: "Développement logiciel"
            // },
            // {
            //     id: 2,
            //     state: "Terminé",
            //     demanded: "Administration système"
            // }
        ],
    },
    {
        id: 3,
        type: "catalog",
        title: "Intelligence Artificielle",
        description: "Domaine stratégique pour toutes les entreprises souhaitant intégrer l'IA dans leurs processus.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [],
        duration: "2-5 jours",
        period: "10–14 juin 2025",
        city: "Douala",
        places: "Ouvert",
        slug: "intelligentie-artificielle",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 500000,
        technologies: [
            {
                id: 0,
                title: "Introduxtion à l'IA",
                duration: "4 jours",
                description: "Principes, cas d'usage, automatisation",
                price: 500000,
                tag: "Intro IA",
            },
            {
                id: 1,
                title: "Machine Learning",
                duration: "5 jours",
                description: "Algorithmes, models predictifs, python & scikit-learn",
                price: 1200000,
                tag: "Machine Learning",
            },
            {
                id: 2,
                title: "IA Génératives pour entreprises",
                duration: "4 jours",
                description: "Assistant IA, atomatisation, optimisation metier",
                price: 600000,
                tag: "IA Génératives",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "Nouveau",
                demanded: "Très demandée"
            },
            // {
            //     id: 1,
            //     state: "Nouveau",
            //     demanded: "Développement logiciel"
            // },
            // {
            //     id: 2,
            //     state: "Terminé",
            //     demanded: "Administration système"
            // }
        ],
    },
    {
        id: 4,
        type: "catalog",
        title: "Cybersécurité",
        description: "Pour les responsables SI et équipes IT chargés de protéger les systèmes d'information.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [],
        duration: "3-4 jours",
        period: "10–14 juin 2025",
        city: "Douala",
        places: "Ouvert",
        slug: "cybersécurité",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 750000,
        technologies: [
            {
                id: 0,
                title: "Sécurité réseau",
                duration: "3 jours",
                description: "Firewalls, VPN, Monitoring",
                price: 750000,
                tag: "Sécurité réseau",
            },
            {
                id: 1,
                title: "Audit cybersécurité",
                duration: "4 jours",
                description: "Test d'intrusion, vulnérabilité, rapports",
                price: 950000,
                tag: "Audit cyber",
            },
            {
                id: 2,
                title: "Gestion des incidents de sécurité",
                duration: "3 jours",
                description: "SIEM, réponse incidents, continuité",
                price: 1100000,
                tag: "Gestion incidents",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "",
                demanded: "Très demandée"
            },
            // {
            //     id: 1,
            //     state: "Nouveau",
            //     demanded: "Développement logiciel"
            // },
            // {
            //     id: 2,
            //     state: "Terminé",
            //     demanded: "Administration système"
            // }
        ],
    },
    {
        id: 5,
        type: "catalog",
        title: "Formation Intra-entreprise",
        description: "Programmes sur mesure dispensés dans vos locaux, adaptés à votre secteur et vos équipes.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [],
        duration: "Sur mesure",
        period: "10–14 juin 2025",
        city: "Douala",
        places: "Ouvert",
        slug: "formation-intra-entreprise",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: "Sur devis",
        technologies: [
            {
                id: 0,
                title: "Audit des besoins avant formation",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "intra-interprise",
            },
            {
                id: 1,
                title: "Supports pédagogiques personnalisés",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "Sur mesure",
            },
            {
                id: 2,
                title: "Attestations de formation remises",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "Certifiant",
            },
            {
                id: 3,
                title: "Suivi post-formation sur 30 jours",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "",
            }
        ],
        popularTags: [
            // {
            //     id: 0,
            //     state: "Nouveau",
            //     demanded: "Développement logiciel"
            // },
            // {
            //     id: 1,
            //     state: "Nouveau",
            //     demanded: "Développement logiciel"
            // },
            // {
            //     id: 2,
            //     state: "Terminé",
            //     demanded: "Administration système"
            // }
        ],
    },
    {
        id: 6,
        type: "packEnterprise",
        title: "Pack Transformation Digitale",
        description: "Programme complet pour accompagner une entreprise dans sa montée en compétences IT. Audit, plan de formation personnalisé et sessions pour les équipes.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "Audit des compétences IT existantes",
            "Plan de formation sur mesure (12 mois)",
            "Sessions de formation pour les équipes (intra)",
            "Attestations de formation remises",
            "Suivi et accompagnement post-formation"
        ],
        duration: "4-5 jours",
        period: "10–14 juin 2025",
        city: "Douala",
        places: "Ouvert",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 3000000,
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
    {
        id: 7,
        type: "packEnterprise",
        title: "Pack Cybersécurité Entreprise",
        description: "Audit de sécurité + formation des équipes IT + plan de remédiation. Idéal pour les entreprises qui veulent protéger leur SI de manière durable.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "Audit cybersécurité complet",
            "Formation sécurité réseau & incidents",
            "Sensibilisation collaborateurs",
            "Plan de remédiation priorisé"
        ],
        duration: "4-5 jours",
        period: "10–14 juin 2025",
        city: "Douala",
        places: "Ouvert",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 2000000,
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
    {
        id: 8,
        type: "packEnterprise",
        title: "Pack Cloud & DevOps Equipe",
        description: "Formation intensive pour une équipe de 3 à 8 personnes sur Docker, Kubernetes et CI/CD — avec mise en pratique sur votre infrastructure.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "3 modules Cloud & DevOps (10 jours)",
            "Cas pratiques sur votre environnement réel",
            "Pour 3 à 8 participants (intra)",
            "Support de cours + labs inclus"
        ],
        duration: "4-5 jours",
        period: "10–14 juin 2025",
        city: "Douala",
        places: "Ouvert",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 'Sur devis',
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
    {
        id: 9,
        type: "calendar",
        title: "DevOps & CI/CD",
        description: "Formation intensive pour une équipe de 3 à 8 personnes sur Docker, Kubernetes et CI/CD — avec mise en pratique sur votre infrastructure.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "3 modules Cloud & DevOps (10 jours)",
            "Cas pratiques sur votre environnement réel",
            "Pour 3 à 8 participants (intra)",
            "Support de cours + labs inclus"
        ],
        duration: "4-5 jours",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        period: "10–14 juin 2025",
        city: "Douala",
        places: "Ouvert",
        min_price: 'Sur devis',
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
    {
        id: 10,
        type: "calendar",
        title: "Cybersecurité Entreprise",
        description: "Formation intensive pour une équipe de 3 à 8 personnes sur Docker, Kubernetes et CI/CD — avec mise en pratique sur votre infrastructure.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "3 modules Cloud & DevOps (10 jours)",
            "Cas pratiques sur votre environnement réel",
            "Pour 3 à 8 participants (intra)",
            "Support de cours + labs inclus"
        ],
        duration: "4 jours",
        period: "20–23 juin 2026",
        city: "Yaoundé",
        places: "Ouvert",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 'Sur devis',
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
    {
        id: 11,
        type: "calendar",
        title: "Data Analytics Python",
        description: "Formation intensive pour une équipe de 3 à 8 personnes sur Docker, Kubernetes et CI/CD — avec mise en pratique sur votre infrastructure.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "3 modules Cloud & DevOps (10 jours)",
            "Cas pratiques sur votre environnement réel",
            "Pour 3 à 8 participants (intra)",
            "Support de cours + labs inclus"
        ],
        duration: "4 jours",
        period: "5–8 juin 2026",
        city: "Douala",
        places: "Ouvert",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 'Sur devis',
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
    {
        id: 12,
        type: "calendar",
        title: "IA Générative Entreprises",
        description: "Formation intensive pour une équipe de 3 à 8 personnes sur Docker, Kubernetes et CI/CD — avec mise en pratique sur votre infrastructure.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "3 modules Cloud & DevOps (10 jours)",
            "Cas pratiques sur votre environnement réel",
            "Pour 3 à 8 participants (intra)",
            "Support de cours + labs inclus"
        ],
        duration: "2 jours",
        period: "14–15 juil 2026",
        city: "Yaoundé",
        places: "Quasi complet",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 'Sur devis',
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },{
        id: 13,
        type: "calendar",
        title: "Architecture Cloud AWS",
        description: "Formation intensive pour une équipe de 3 à 8 personnes sur Docker, Kubernetes et CI/CD — avec mise en pratique sur votre infrastructure.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "3 modules Cloud & DevOps (10 jours)",
            "Cas pratiques sur votre environnement réel",
            "Pour 3 à 8 participants (intra)",
            "Support de cours + labs inclus"
        ],
        duration: "5 jours",
        period: "21–25 juil 2026",
        city: "Douala",
        places: "Ouvert",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 'Sur devis',
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
    {
        id: 14,
        type: "calendar",
        title: "Machine Learning",
        description: "Formation intensive pour une équipe de 3 à 8 personnes sur Docker, Kubernetes et CI/CD — avec mise en pratique sur votre infrastructure.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "3 modules Cloud & DevOps (10 jours)",
            "Cas pratiques sur votre environnement réel",
            "Pour 3 à 8 participants (intra)",
            "Support de cours + labs inclus"
        ],
        duration: "5 jours",
        period: "11–15 juin 2026",
        city: "Yaoundé",
        places: "Ouvert",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 'Sur devis',
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
    {
        id: 14,
        type: "calendar",
        title: "Power BI & Data Viz",
        description: "Formation intensive pour une équipe de 3 à 8 personnes sur Docker, Kubernetes et CI/CD — avec mise en pratique sur votre infrastructure.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "3 modules Cloud & DevOps (10 jours)",
            "Cas pratiques sur votre environnement réel",
            "Pour 3 à 8 participants (intra)",
            "Support de cours + labs inclus"
        ],
        duration: "3 jours",
        period: "25–27 août 2026",
        city: "Douala",
        places: "Ouvert",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 'Sur devis',
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
];